import { api } from "@/api/client";
import type { DocumentListResponse } from "@/types/document";

export interface MatrixStakeholderRef {
  id: string;
  nama: string;
  tipe?: string | null;
}

export interface MatrixDimensiRef {
  id: string;
  kode: string;
  nama: string;
}

export interface MatrixCell {
  stakeholder_id: string;
  dimensi_id: string;
  count: number;
}

export interface MatrixTotals {
  by_stakeholder: Record<string, number>;
  by_dimensi: Record<string, number>;
  grand: number;
}

export interface DocumentMatrixResponse {
  stakeholders: MatrixStakeholderRef[];
  dimensi: MatrixDimensiRef[];
  cells: MatrixCell[];
  totals: MatrixTotals;
}

export interface MatrixFilters {
  jenis_pnbp_id?: string;
  tahun?: number;
  status_id?: string;
}

export function getDocumentMatrix(filters: MatrixFilters = {}) {
  return api.get<DocumentMatrixResponse>("/documents/matrix", filters);
}

export function getDocumentMatrixCell(params: {
  stakeholder_id: string;
  dimensi_id: string;
  page?: number;
  page_size?: number;
} & MatrixFilters) {
  return api.get<DocumentListResponse>("/documents/matrix/cell", params);
}
